import { useContext, useEffect } from "react";
import { Context } from "../../context";
import { getCustomerAccessTokenMultipassMutation, getCustomerQuery } from "../../queries/storefront-graphql";
import { storefrontClient } from "../../App";
import LoadingGif from "../../assets/common/Flask-3s-200px.svg"

export const Auth = (props: any) => {
  const { loginUser } = useContext(Context);

  useEffect(() => {
    const multipassToken = props.match.params.token;

    const accessTokenMutation = getCustomerAccessTokenMultipassMutation(multipassToken);
    storefrontClient.send(accessTokenMutation).then(async ({ model }: any) => {
      if (model.customerAccessTokenCreateWithMultipass.customerAccessToken !== null) {
        // Multipass login Successful
        const { accessToken, expiresAt } = model.customerAccessTokenCreateWithMultipass.customerAccessToken;
        storefrontClient.send(getCustomerQuery(accessToken))
          .then(async ({ data }: any) => {

            const customerTags = data.customer.tags;
            let role = "";
            if (customerTags.find((t: any) => t === "merch_store_admin")) role = "ADMIN";
            if (customerTags.find((t: any) => t === "merch_store_superuser")) role = "SUPERUSER";
            if (customerTags.find((t: any) => t === "merch_store_merchologist")) role = "MERCHOLOGIST";
            if (role !== "") {
              loginUser(accessToken, expiresAt, data.customer.email, true, role);
              const { history } = props;
              history.push('/admin/group-orders');
            } else {
              console.error(`No user role defined for ${data.customer.email}`);
            }
          });
      } else {
        console.error('Error on Multipass authentication');
        console.error(model.customerAccessTokenCreateWithMultipass.customerUserErrors);
      }
    })
  })
  return (
      <div className="h-screen flex items-center justify-center">
        <img src={LoadingGif} alt="loading flask" width="100px"/>
      </div>
  )
}

